import React from "react";

const HeaderContainer = ({ children }) =>
	(<div className="navbar">
		<div className="navbar-inner">
			<div className="navbar-container">{children}</div>
		</div>
	</div>);

export default HeaderContainer;


/** WEBPACK FOOTER **
 ** ./src/scripts/components/header/HeaderContainer.jsx
 **/